import React, {useEffect, useState} from 'react';
import {Box, Button} from 'adminlte-2-react';

function CustomBox({
  history,
  children,
  title,
  customOptions,
  showBackButton = false,
  onBackPress,
  footer,
}) {
  const mOnBackPress = onBackPress ? onBackPress : () => history.goBack();

  return (
    <Box
      header={
        <>
          {showBackButton && (
            <Button
              type="default"
              size="sm"
              icon="fas-arrow-left"
              onClick={mOnBackPress}
            />
          )}

          <h3
            className="box-title"
            style={showBackButton ? {marginLeft: 5} : {}}>
            {title}
          </h3>
        </>
      }
      customOptions={<div style={{marginTop: 6}}>{customOptions}</div>}
      footer={footer}>
      {children}
    </Box>
  );
}

export {CustomBox};
